import { DirectSalesState, DirectSalesStatusOption } from 'components/common/types/DirectSalesCampaign.types';
import { Color } from 'lib/Chip/Chip.types';

export interface StatusPanelProps {
  lineState: DirectSalesState;
}

export enum DirectSalesStatusLabel {
  DRAFT = 'Draft',
  OPTION = 'Option',
  PROPOSAL = 'Proposal',
  CONFIRMED = 'Confirmed',
  CANCELLED = 'Cancelled',
  DELETED = 'Deleted',
  MIXED = 'Mixed',
  LIVE = 'Live',
  ENDED = 'Ended',
}

interface StatusSettingsRecord {
  text: DirectSalesStatusLabel;
  style: Color;
}

export type StatusSettings = Record<DirectSalesStatusOption, StatusSettingsRecord>;

export type StatusSettingsItem = StatusSettings[keyof StatusSettings];

const DRAFT_SETTINGS = {
  text: DirectSalesStatusLabel.DRAFT,
  style: Color.YELLOW,
};

const PROPOSAL_SETTINGS = {
  text: DirectSalesStatusLabel.PROPOSAL,
  style: Color.PRIMARY,
};

export const STATUS_SETTINGS: StatusSettings = {
  [DirectSalesStatusOption.DRAFT_UPDATING]: DRAFT_SETTINGS,
  [DirectSalesStatusOption.DRAFT_SOLVED]: DRAFT_SETTINGS,
  [DirectSalesStatusOption.DRAFT_FAILED_SOLVE]: DRAFT_SETTINGS,
  [DirectSalesStatusOption.DRAFT_PRICED]: DRAFT_SETTINGS,
  [DirectSalesStatusOption.DRAFT_FAILED_PRICE]: DRAFT_SETTINGS,
  [DirectSalesStatusOption.DRAFT_SOLVING]: DRAFT_SETTINGS,
  [DirectSalesStatusOption.DRAFT_PROPOSAL_SOLVING]: DRAFT_SETTINGS,
  [DirectSalesStatusOption.DRAFT_SOLVING_OPTION_RESERVATION]: DRAFT_SETTINGS,
  [DirectSalesStatusOption.DRAFT_SOLVING_CONFIRMED_RESERVATION]: DRAFT_SETTINGS,
  [DirectSalesStatusOption.DRAFT_PRICING_OPTION_RESERVATION]: DRAFT_SETTINGS,
  [DirectSalesStatusOption.DRAFT_PRICING_CONFIRMED_RESERVATION]: DRAFT_SETTINGS,
  [DirectSalesStatusOption.DRAFT_PROPOSAL_PRICING]: DRAFT_SETTINGS,
  [DirectSalesStatusOption.PROPOSAL_SOLVING]: PROPOSAL_SETTINGS,
  [DirectSalesStatusOption.PROPOSAL_PROPOSAL_PRICING]: PROPOSAL_SETTINGS,
  [DirectSalesStatusOption.PROPOSAL_PRICING_OPTION_RESERVATION]: PROPOSAL_SETTINGS,
  [DirectSalesStatusOption.PROPOSAL_PRICING_CONFIRMED_RESERVATION]: PROPOSAL_SETTINGS,
  [DirectSalesStatusOption.PROPOSAL_SOLVING_OPTION_RESERVATION]: PROPOSAL_SETTINGS,
  [DirectSalesStatusOption.PROPOSAL_SOLVING_CONFIRMED_RESERVATION]: PROPOSAL_SETTINGS,
  [DirectSalesStatusOption.DRAFT]: {
    text: DirectSalesStatusLabel.DRAFT,
    style: Color.YELLOW,
  },
  [DirectSalesStatusOption.MIXED]: {
    text: DirectSalesStatusLabel.MIXED,
    style: Color.LIGHT_PURPLE,
  },
  [DirectSalesStatusOption.OPTION]: {
    text: DirectSalesStatusLabel.OPTION,
    style: Color.ORANGE,
  },
  [DirectSalesStatusOption.PROPOSAL]: PROPOSAL_SETTINGS,
  [DirectSalesStatusOption.CONFIRMED]: {
    text: DirectSalesStatusLabel.CONFIRMED,
    style: Color.GREEN,
  },
  [DirectSalesStatusOption.CANCELLED]: {
    text: DirectSalesStatusLabel.CANCELLED,
    style: Color.GREY,
  },
  [DirectSalesStatusOption.DELETED]: {
    text: DirectSalesStatusLabel.DELETED,
    style: Color.GREY,
  },
  [DirectSalesStatusOption.LIVE]: {
    text: DirectSalesStatusLabel.LIVE,
    style: Color.LIME,
  },
  [DirectSalesStatusOption.ENDED]: {
    text: DirectSalesStatusLabel.ENDED,
    style: Color.GREY,
  },
};
